import React, { useRef } from 'react';
var VeltActivityLogHeaderFilterContent = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-header-filter-content", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltActivityLogHeaderFilterContent;
